export enum FileUploadStatusEnum {
  Pending = 'Pending',
  Uploading = 'Uploading',
  Completed = 'Completed',
  Failed = 'Failed',
  FailedSharing = 'FailedSharing',
  Canceled = 'Canceled',
}
